import { useTranslation } from "react-i18next"

type UseTranslationsParams = {
  baselineSavedDate?: string
  baselineSavedBy?: string
}

export const useTranslations = ({
  baselineSavedDate = "",
  baselineSavedBy,
}: UseTranslationsParams = {}): Translations => {
  const { t } = useTranslation()
  const { t: tProject } = useTranslation("project")

  const savedByYou = tProject("projectNavBar.savedByYou", {
    defaultValue: defaultTranslations.savedByYou,
  })

  return {
    saveBasePlanBtnLabel: tProject("projectNavBar.saveBasePlanBtnLabel", {
      defaultValue: defaultTranslations.saveBasePlanBtnLabel,
    }),
    basePlanSaveSuccessTitle: tProject("projectNavBar.basePlanSaveSuccessTitle", {
      defaultValue: defaultTranslations.basePlanSaveSuccessTitle,
    }),
    basePlanSavedSuccessText: tProject("projectNavBar.basePlanSavedSuccessText", {
      defaultValue: defaultTranslations.basePlanSavedSuccessText,
    }),
    basePlanSaveFailureTitle: tProject("projectNavBar.basePlanSaveFailureTitle", {
      defaultValue: defaultTranslations.basePlanSaveFailureTitle,
    }),
    basePlanSavedFailureText: tProject("projectNavBar.basePlanSavedFailureText", {
      defaultValue: defaultTranslations.basePlanSavedFailureText,
    }),
    saveBasePlanConfirmTitle: tProject("projectNavBar.saveBasePlanConfirmTitle", {
      defaultValue: defaultTranslations.saveBasePlanConfirmTitle,
    }),
    saveBasePlanConfirmBtnLabel: tProject("projectNavBar.saveBasePlanConfirmBtnLabel", {
      defaultValue: defaultTranslations.saveBasePlanConfirmBtnLabel,
    }),
    saveBasePlanConfirmText: tProject("projectNavBar.saveBasePlanConfirmText", {
      defaultValue: defaultTranslations.saveBasePlanConfirmText,
    }),
    hideBaselineBarText: tProject("projectNavBar.hideBaselineBarText", {
      defaultValue: defaultTranslations.hideBaselineBarText,
    }),
    showBaselineBarText: tProject("projectNavBar.showBaselineBarText", {
      defaultValue: defaultTranslations.showBaselineBarText,
    }),
    hideActualBarText: tProject("projectNavBar.hideActualBarText", {
      defaultValue: defaultTranslations.hideActualBarText,
    }),
    showActualBarText: tProject("projectNavBar.showActualBarText", {
      defaultValue: defaultTranslations.showActualBarText,
    }),
    baselineSavedText: tProject("projectNavBar.baselineSavedText", {
      defaultValue: defaultTranslations.baselineSavedText,
      date: baselineSavedDate,
      saved_by: baselineSavedBy || savedByYou,
    }),
    savedByYou,
    fullScreenAriaLabel: tProject("projectNavBar.fullScreenAriaLabel", {
      defaultValue: defaultTranslations.fullScreenAriaLabel,
    }),
    menuAriaLabel: tProject("projectNavBar.menuAriaLabel", {
      defaultValue: defaultTranslations.menuAriaLabel,
    }),
    projectSettingsButtonLabel: tProject("projectNavBar.projectSettingsButtonLabel", {
      defaultValue: defaultTranslations.projectSettingsButtonLabel,
    }),
    archiveProjectBtnLabel: tProject("projectNavBar.archiveProjectBtnLabel", {
      defaultValue: defaultTranslations.archiveProjectBtnLabel,
    }),
    deleteProjectBtnLabel: tProject("projectNavBar.deleteProjectBtnLabel", {
      defaultValue: defaultTranslations.deleteProjectBtnLabel,
    }),
    deleteProjectSecondaryText: tProject("projectNavBar.deleteProjectSecondaryText", {
      defaultValue: defaultTranslations.deleteProjectSecondaryText,
    }),
    basicInfoTabLabel: tProject("projectNavBar.basicInfoTabLabel", {
      defaultValue: defaultTranslations.basicInfoTabLabel,
    }),
    tasksTabLabel: t("appNavBar.tasksLabel", {
      defaultValue: defaultTranslations.tasksTabLabel,
    }),
    ganttChartTabLabel: tProject("projectNavBar.ganttChartTabLabel", {
      defaultValue: defaultTranslations.ganttChartTabLabel,
    }),
    kanbanTabLabel: tProject("projectNavBar.kanbanTabLabel", {
      defaultValue: defaultTranslations.kanbanTabLabel,
    }),
    noStartDate: tProject("projectNavBar.noStartDate", {
      defaultValue: defaultTranslations.noStartDate,
    }),
    noEndDate: tProject("projectNavBar.noEndDate", {
      defaultValue: defaultTranslations.noEndDate,
    }),
    addStartDate: tProject("projectNavBar.addStartDate", {
      defaultValue: defaultTranslations.addStartDate,
    }),
    addEndDate: tProject("projectNavBar.addEndDate", {
      defaultValue: defaultTranslations.addEndDate,
    }),
    planTitle: tProject("projectNavBar.planTitle", {
      defaultValue: defaultTranslations.planTitle,
    }),
    enableTimeComponentLabel: tProject("projectNavBar.enableTimeComponentLabel", {
      defaultValue: defaultTranslations.enableTimeComponentLabel,
    }),
    deleteProjectdSuccessText: tProject("projectNavBar.deleteProjectdSuccessText", {
      defaultValue: defaultTranslations.deleteProjectdSuccessText,
    }),
    deleteProjectdFailureText: tProject("projectNavBar.deleteProjectdFailureText", {
      defaultValue: defaultTranslations.deleteProjectdFailureText,
    }),
    deleteProjectConfirmTitle: tProject("projectNavBar.deleteProjectConfirmTitle", {
      defaultValue: defaultTranslations.deleteProjectConfirmTitle,
    }),
    deleteProjectConfirmText: tProject("projectNavBar.deleteProjectConfirmText", {
      defaultValue: defaultTranslations.deleteProjectConfirmText,
    }),
    archiveProjectdSuccessText: tProject("projectNavBar.archiveProjectdSuccessText", {
      defaultValue: defaultTranslations.archiveProjectdSuccessText,
    }),
    archiveProjectdFailureText: tProject("projectNavBar.archiveProjectdFailureText", {
      defaultValue: defaultTranslations.archiveProjectdFailureText,
    }),
    archiveProjectConfirmTitle: tProject("projectNavBar.archiveProjectConfirmTitle", {
      defaultValue: defaultTranslations.archiveProjectConfirmTitle,
    }),
    archiveProjectConfirmText: tProject("projectNavBar.archiveProjectConfirmText", {
      defaultValue: defaultTranslations.archiveProjectConfirmText,
    }),
    boardMenuAriaLabel: tProject("projectNavBar.boardMenuAriaLabel", {
      defaultValue: defaultTranslations.boardMenuAriaLabel,
    }),
    boardMenuSubHeader: tProject("projectNavBar.boardMenuSubHeader", {
      defaultValue: defaultTranslations.boardMenuSubHeader,
    }),
    calendarTabLabel: tProject("projectNavBar.calendarTabLabel", {
      defaultValue: defaultTranslations.calendarTabLabel,
    }),
    projectPlanToolTipLabel: tProject("projectNavBar.projectPlanToolTipLabel", {
      defaultValue: defaultTranslations.projectPlanToolTipLabel,
    }),
    todoListTabLabel: t("appNavBar.todosLabel", {
      defaultValue: defaultTranslations.todoListTabLabel,
    }),
    notificationsLabel: t("appNavBar.notificationsLabel", {
      defaultValue: defaultTranslations.notificationsLabel,
    }),
    dashboardTabLabel: tProject("projectNavBar.dashboardTabLabel", {
      defaultValue: defaultTranslations.dashboardTabLabel,
    }),
    reportedHoursTabLabel: tProject("projectNavBar.reportedHoursTabLabel", {
      defaultValue: defaultTranslations.reportedHoursTabLabel,
    }),
    chatLabel: tProject("projectNavBar.chatLabel", {
      defaultValue: defaultTranslations.chatLabel,
    }),
  }
}

const defaultTranslations = {
  saveBasePlanBtnLabel: "Save base plan",
  basePlanSaveSuccessTitle: "Success",
  basePlanSavedSuccessText: "Base plan saved",
  basePlanSaveFailureTitle: "Failed",
  basePlanSavedFailureText: "Failed to save base plan",
  saveBasePlanConfirmTitle: `This cannot be done twice`,
  saveBasePlanConfirmBtnLabel: `Save`,
  saveBasePlanConfirmText: "Once you save base plan it can not be reverted or changed.",
  hideBaselineBarText: "Hide baseline bar",
  showBaselineBarText: "Show baseline bar",
  hideActualBarText: "Hide actual bar",
  showActualBarText: "Show actual bar",
  baselineSavedText: "{{saved_by}} saved baseline plan on {{date}}.",
  savedByYou: "you",
  fullScreenAriaLabel: "Open in full screen",
  menuAriaLabel: "Open menu",
  projectSettingsButtonLabel: "Project settings",
  archiveProjectBtnLabel: "Archive project",
  deleteProjectBtnLabel: "Delete project",
  deleteProjectSecondaryText: "Permanently removes the project from database.",
  basicInfoTabLabel: "Basic info",
  tasksTabLabel: "Tasks",
  ganttChartTabLabel: "Gantt",
  kanbanTabLabel: "Kanban",
  todoListTabLabel: "To-dos",
  calendarTabLabel: "Calendar",
  dashboardTabLabel: "Summary",
  reportedHoursTabLabel: "Reported hours",
  chatLabel: "Chat",
  noStartDate: "No start",
  noEndDate: "No end",
  addStartDate: "Add start",
  addEndDate: "Add end",
  planTitle: "Schedule:",
  enableTimeComponentLabel: "Enable scheduling in hours and minutes",
  deleteProjectdSuccessText: "Project deleted, redirecting . . .",
  deleteProjectdFailureText: "Failed to delete project",
  deleteProjectConfirmTitle: "Delete this project",
  deleteProjectConfirmText:
    "Continuing this action will delete all data linked with this project including all tasks. After this it can not be restored",
  archiveProjectdSuccessText: "Project archived",
  archiveProjectdFailureText: "Failed to archive project",
  archiveProjectConfirmTitle: "Archive this project",
  archiveProjectConfirmText:
    "Archiving this project also archives all the resources linked with this project. However you can unarchive project later",
  boardMenuAriaLabel: "Open board menu",
  boardMenuSubHeader: "Board column's visibility",
  projectPlanToolTipLabel: "Plan is inherited from tasks",
  notificationsLabel: "Notifications",
}

type Translations = typeof defaultTranslations
